// skipcq: JS-W1028
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { DETAIL_MUTED, PRIMARY_DETAIL_TEXT } from '../../utils/theme';
import BeerReviewStatsRow from './BeerReviewStatsRow';

export const BEER_REVIEW_STATS_EMPTY_MESSAGE =
  'Share the app with your guests to see your stats come to life!';

/**
 * @param {object} props
 * @param {string} props.title
 * @param {'recently-added' | 'top-rated'} props.section
 * @param {Array<object>} props.beers
 * @param {Record<string, string>} props.tagLabelMap
 * @param {Record<string, string>} props.styleLabelMap
 * @param {string} [props.breweryId]
 * @param {(params: { breweryId: string, beerId: string, section: 'recently-added' | 'top-rated' }) => void} [props.onRowClick]
 */
function BeerReviewStatsSection({
  title,
  section,
  beers,
  tagLabelMap,
  styleLabelMap,
  breweryId,
  onRowClick,
}) {
  const hasBeers = Array.isArray(beers) && beers.length > 0;

  return (
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography
        variant="subtitle1"
        fontWeight={700}
        sx={{ color: PRIMARY_DETAIL_TEXT, mb: 1 }}
      >
        {title}
      </Typography>
      {hasBeers ? (
        <Box>
          {beers.map((beer) => (
            <BeerReviewStatsRow
              key={beer.id}
              beer={beer}
              tagLabelMap={tagLabelMap}
              styleLabelMap={styleLabelMap}
              breweryId={breweryId}
              section={section}
              onRowClick={onRowClick}
            />
          ))}
        </Box>
      ) : (
        <Typography
          variant="body2"
          sx={{
            color: DETAIL_MUTED,
            textAlign: 'center',
            py: 3,
            px: 1,
          }}
        >
          {BEER_REVIEW_STATS_EMPTY_MESSAGE}
        </Typography>
      )}
    </Box>
  );
}

BeerReviewStatsSection.propTypes = {
  title: PropTypes.string.isRequired,
  section: PropTypes.oneOf(['recently-added', 'top-rated']).isRequired,
  beers: PropTypes.arrayOf(PropTypes.object).isRequired,
  tagLabelMap: PropTypes.objectOf(PropTypes.string).isRequired,
  styleLabelMap: PropTypes.objectOf(PropTypes.string).isRequired,
  breweryId: PropTypes.string,
  onRowClick: PropTypes.func,
};

export default BeerReviewStatsSection;
